<div class="message_center">
  <div class="message_center__container flex">
    @if (programPartnerTypeId === 0) {
      <h1 class="text-danger">You must Assign a User Type</h1>
    }
    <lib-message-center-header
      [unreadCount]="unReadMessageCount"
      (newMessageSelected)="handleNewMessageSelected()">
      <div class="message_center__header-button-container">
        <button mat-stroked-button (click)="handleNewMessageSelected()" data-pw="btnNewMessage"
                class="new_button primary_materials_button">
          <mat-icon>add</mat-icon>
          New Message
        </button>
      </div>
    </lib-message-center-header>
    <div class="flex">
      <div class="flex-none col-left">
        <lib-message-center-thread-list
          [isLoading]="isLoading"
          [threads]="filteredThreads"
          [hasChanges]="messageInProgress"
          [selectedThread]="selectedThread"
          (threadChanged)="handleThreadChanged($event)">
          <lib-message-center-thread-filter
            [threads]="threads"
            (filteredThreads)="handleFilteredThreadsChanged($event)">
          </lib-message-center-thread-filter>
        </lib-message-center-thread-list>
      </div>
      <div class="flex flex-column bg-white" style="width: 100%; height: calc(100vh - 180px);">
        <div class="message-center-thread-content ">
          @switch (messageState) {
            @case ('display') {
              <div chat-header
                   class="thread_header stick message-center-thread-content-header"
                   [thread]="selectedThread"
                   (markThreadAsUnread)="markAsUnread()"
                   (archiveThread)="archiveThread()">
              </div>
              <div chat-interface
                   #chat
                   [thread]="selectedThread"
                   (scrollDown)="scrollToChatBottom()"
                   class="message-center-thread-content-list">
              </div>
              <div chat-form
                   #chatForm
                   [thread]="selectedThread"
                   [createTopicPayload]="createTopicPayload"
                   (sendMessage)="handleMessageSent();"
                   (messageChanged)="handleMessageChanges($event)"
                   (scrollDown)="scrollToChatBottom()"
                   (newThreadCreated)="handleNewThreadCreated($event)"
                   class="message-center-thread-content-footer">
              </div>
            }
            @case ('create') {
              <lib-message-center-category-selector
                [programPartnerTypeId]="programPartnerTypeId"
                [accountId]="accountId"
                (createNewThread)="handleNewThread($event)">
              </lib-message-center-category-selector>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

